<!-- Datatable -->
<ngx-datatable
    #table
    class="material striped"
    [columnMode]="'force'"
    [headerHeight]="50"
    [footerHeight]="'auto'"
    [rowHeight]="50"
    [limit]="10"
    [rows]="notifications"
    [messages]="{emptyMessage: 'DATATABLE.EMPTYMESSAGE.NOTIFICATIONS.TITLE' | translate}"
    [loadingIndicator]="loadingIndicator">
    <ngx-datatable-column name="title">
        <ng-template let-column="column" ngx-datatable-header-template>
            <span [innerHtml]="'DATATABLE.COLUMN.EVENT.NAME.TITLE' | translate"></span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{ row?.title }}</span>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="body">
        <ng-template let-column="column" ngx-datatable-header-template>
            <span [innerHtml]="'DATATABLE.COLUMN.ACTIONS.TITLE' | translate"></span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{ row?.body }}</span>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="created">
        <ng-template let-column="column" ngx-datatable-header-template>
            <span [innerHtml]="'DATATABLE.COLUMN.DATE.TITLE' | translate"></span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{ row?.created | amFromUtc | amLocal | amLocale: locale | amDateFormat: 'L LT' }}</span>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-footer>
        <ng-template
            ngx-datatable-footer-template
            let-rowCount="rowCount"
            let-pageSize="pageSize"
            let-curPage="curPage"
            let-isVisible="isVisible">
            <div class="pl-2 pt-2">
                <span>
                    {{ rowCount }} {{ ((rowCount === 1) ? ('DATATABLE.FOOTER.NOTIFICATIONS.SINGLE.LABEL' | translate) : ('DATATABLE.FOOTER.NOTIFICATIONS.MULTIPLE.LABEL' | translate)) }}
                </span>
            </div>
            <datatable-pager
                [pagerLeftArrowIcon]="'datatable-icon-left'"
                [pagerRightArrowIcon]="'datatable-icon-right'"
                [pagerPreviousIcon]="'datatable-icon-prev'"
                [pagerNextIcon]="'datatable-icon-skip'"
                [page]="curPage"
                [size]="pageSize"
                [count]="rowCount"
                [hidden]="!((rowCount / pageSize) > 1)"
                (change)="table.onFooterPage($event)">
            </datatable-pager>
        </ng-template>
    </ngx-datatable-footer>
</ngx-datatable>
